module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-old-56b7e87a7d8bcf5bdff1596c76974d92.png";